export class SuccessHandlerHelper {
    rawData;
    data = {
      code: 200,
      error: undefined,
      isError: false,
      messages: [],
      timestamp: Date.now(),
    };
  
    constructor(data) {
      this.rawData = data;
      this.setSuccess();
    }
  
    setSuccess = () => {
      const messages = [];
  
      for (const i in this.rawData) {
        if (typeof this.rawData[i] === 'string') {
          messages.push(this.rawData[i]);
        }
      }
      this.data.data = this.rawData;
      this.data.messages = messages;
    };
  }
  